import { devSimulatePing } from '~/rage/decorators';
import { IFeedbackService } from './feedbackServiceTypes';

export class FeedbackServiceStub implements IFeedbackService {
	@devSimulatePing()
	public async sendFeedback(title: string, message: string): Promise<void> {
		console.log('feedback:sendFeedback', { title, message });
	}

	@devSimulatePing()
	public async close(): Promise<void> {
		console.log('feedback:close');
	}
}
